import { Typography } from "@material-tailwind/react";
import { StatusChip } from "@/components/status-chip";
import { attachmentChipStatuses } from "@/constants/attachment-chip-statuses";

export function ResultPendingDocuments({ documents }) {
  if (!documents?.length) return null;

  return (
    <div className="mt-6">
      <Typography className="text-lg font-bold mb-2 text-red-600">
        Documentos Pendientes
      </Typography>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-black border border-gray-300">
          <thead className="bg-gray-100 border-b border-gray-300">
            <tr>
              <th className="px-4 py-2 text-left font-medium">Nombre</th>
              <th className="px-4 py-2 text-left font-medium">Período</th>
              <th className="px-4 py-2 text-left font-medium">Estado</th>
            </tr>
          </thead>
          <tbody>
            {documents.map((doc, i) => (
              <tr key={i} className="border-b border-gray-200">
                <td className="px-4 py-1">{doc.name}</td>
                <td className="px-4 py-1">{doc.period}</td>
                <td className="px-4 py-1">
                  <StatusChip options={attachmentChipStatuses} value={doc.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
